const LoadingSkeleton = () => {
  return (
    <div className="space-y-8">
      {/* Header Skeleton */}
      <div className="space-y-4">
        <div className="h-8 bg-muted animate-pulse rounded w-2/3"></div>
        <div className="h-4 bg-muted animate-pulse rounded w-1/2"></div>
      </div>
      {/* Filters Skeleton */}
      <div className="bg-card border border-border rounded-lg p-4">
        <div className="h-6 bg-muted animate-pulse rounded w-1/4 mb-4"></div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {Array.from({ length: 4 })?.map((_, index) => (
            <div key={index} className="h-10 bg-muted animate-pulse rounded"></div>
          ))}
        </div>
      </div>
      {/* Articles Grid Skeleton */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        <div className="lg:col-span-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {Array.from({ length: 6 })?.map((_, index) => (
              <div key={index} className="bg-card border border-border rounded-lg overflow-hidden">
                <div className="h-48 bg-muted animate-pulse"></div>
                <div className="p-6 space-y-3">
                  <div className="h-6 bg-muted animate-pulse rounded"></div>
                  <div className="h-4 bg-muted animate-pulse rounded w-3/4"></div>
                  <div className="h-4 bg-muted animate-pulse rounded w-1/2"></div>
                  <div className="flex space-x-2">
                    <div className="h-6 bg-muted animate-pulse rounded w-16"></div>
                    <div className="h-6 bg-muted animate-pulse rounded w-16"></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Sidebar Skeleton */}
        <div className="lg:col-span-1 space-y-6">
          {Array.from({ length: 3 })?.map((_, index) => (
            <div key={index} className="bg-card border border-border rounded-lg p-6">
              <div className="h-6 bg-muted animate-pulse rounded w-3/4 mb-4"></div>
              <div className="space-y-2">
                <div className="h-4 bg-muted animate-pulse rounded"></div>
                <div className="h-4 bg-muted animate-pulse rounded w-2/3"></div>
                <div className="h-8 bg-muted animate-pulse rounded"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton;